import React, { useContext, useRef, useState } from 'react';
import { FC } from 'react';
import { Date, Description, Image, ImageSection, Title, Wrapper } from '@components/Article/Article.elements';
import { getImageBaseURL } from '../../constants';
import { IArticleItem } from '../../interfaces/Article';
import moment from "moment";

interface ArticleProps {
    article: IArticleItem;
}

const ArticleTemplate: FC<ArticleProps> = ({ article }) => (
    <Wrapper>
        <Date>{moment(article.publicationDate).format('D. M. YYYY')}</Date>
        <Title>{article.title}</Title>
        <ImageSection>
            <Image src={`${getImageBaseURL()}/media/articles/${article.photo}`} />
        </ImageSection>
        <Description dangerouslySetInnerHTML={{ __html: article.text }} />
    </Wrapper>
);

export default ArticleTemplate;
